import React from "react";
import {makeStyles, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import CheckIcon from "../../widget/streamline-icon/CheckIcon";

const useStyles = makeStyles((theme) => ({
    documentsWrap: {
        backgroundColor: theme.palette.primary[100],
        marginBottom: theme.spacing(5),
        display: "flex",
        padding: theme.spacing(3),
    },
    iconCheck: {
        color: theme.palette.primary[900],
        marginRight: theme.spacing(3.5),
    },
    documentsLabel: {
        fontSize: 14,
        fontWeight: 400,
        color: "#000"
    }
}));

const CustomSuccess = ({title, text}) => {
    const classes = useStyles();

    return (
        <>
            {(title || text) && (
                <Grid
                    item
                    md={12}
                    xs={12}
                    sm={12}
                    className={classes.documentsWrap}
                >
                    <CheckIcon
                        className={classes.iconCheck}
                    />

                    <div>
                        <span>
                            {title && (
                                <Typography
                                    variant="h6"
                                    color="textPrimary"
                                >
                                    {title}
                                </Typography>
                            )}
                            {text && (
                                <Typography
                                    color="textSecondary"
                                    className={classes.documentsLabel}
                                >
                                    {text}
                                </Typography>
                            )}
                        </span>
                    </div>
                </Grid>
            )}
        </>
    );
};


CustomSuccess.defaultProps = {
    title: "",
    text: ""
};

CustomSuccess.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
};

export default CustomSuccess;
